import useServices from './useServices'
import useTherapists from './useTherapists'

const useTherapist = (therapistId: number) => {
  const { therapists, isLoadingTherapists } = useTherapists('all')
  const { services } = useServices()

  const therapist = therapists?.find((therapist) => therapist.therapistId === therapistId)
  const therapistServices = services
    ?.filter((service) => therapist?.services?.includes(service.id))
    .map((service) => ({
      ...service,
      // this is a strange mapping, that is used almost everywhere
      // it should probably be calculated elsewhere in the future
      price: therapist?.prices?.find((priceObj) => priceObj.serviceId === service.id)?.price,
    }))

  return { therapist, therapistServices, isLoadingTherapists }
}

export default useTherapist
